import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  highlight: {
    color: theme.palette.secondary[500],
    backgroundColor: 'inherit'
  },
  icon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(0.5),
    color: theme.palette.primary[400],
    backgroundColor: theme.palette.secondary[200],
    borderRadius: '50%'
  },
  subtitle: {
    color: theme.palette.primary[400],
    lineHeight: 1.25,
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  name: {
    lineHeight: 1.25,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }
}));

export default createClasses;
